// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"home_backgroundImage__nCnHc","typeCursorBlink":"home_typeCursorBlink__Jsj4n","blinking":"home_blinking__ZaVT_"};